import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65243d41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConstructionAdd" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "施工申请情况", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "进场施工安装条件", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "其他说明")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_8 = { class: "submit-btn" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onMounted, reactive, ref } from 'vue'
import dayjs from 'dayjs'
import { saveProject, ConstructionApply } from '@/apis/construction'
import { Toast } from 'vant'
import { useRouter } from 'vue-router'
import { getCity } from '@/apis/common'
import { getProjectDetail } from '@/apis/projectList'
import { ProjectData } from '@/apis/projectList'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const EndshowPicker = ref(false)
const state = reactive({
  waterName: '',
  materialName: '',
  finish_date: '',
  provinceName: '',
  address: '',
  pid: 0,
  city_list: [], //城市 选择数据
  name: '',
  formData: {} as saveProject
})

const currentDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm')))

const project_detail = ref({} as ProjectData)
const cascaderValue = ref('')

const CityshowPicker = ref(false)

// 现场水电气道路情况
const WaterShowPicker = ref(false)
// 现场水电气道路情况
const waterColumns = [
  { id: 1, name: '已通' },
  { id: 2, name: '未通' }
]
//现场水电气道路情况 选择后达到的值
const onWaterConfirm = (data: { id: string; name: string }) => {
  console.log('data: ', data)
  state.waterName = data.name
  state.formData.sqdd_state = data.id
  WaterShowPicker.value = false
}

const onEndConfirm = data => {
  state.formData.finish_date = formatDate(data)
  EndshowPicker.value = false
}
//安装用物料准备情况
const MaterialShowPicker = ref(false)
const materialColumns = [
  { id: 1, name: '已准备' },
  { id: 2, name: '未准备' }
]
const onMaterialConfirm = (data: { id: string; name: string }) => {
  console.log('data: ', data)
  state.materialName = data.name
  state.formData.prepare_state = data.id
  MaterialShowPicker.value = false
}
const showCalendar = ref(false)
const onCalendarConfirm = date => {
  const [start, end] = date
  let s = formatDate(start)
  let e = formatDate(end)
  let days = dayjs(e).diff(dayjs(s), 'day') + 1
  state.formData.supply_days = days.toString()
  showCalendar.value = false
}
const onClickTab = data => {
  console.log('tab', data)
}

const onCityConfirm = ({ selectedOptions }) => {
  state.provinceName = selectedOptions.map(option => option.text).join('')
  console.log(selectedOptions)

  // if (selectedOptions.length >= 0) state.project.province_id = selectedOptions[0].value
  // if (selectedOptions.length >= 1) state.project.city_id = selectedOptions[1].value
  // if (selectedOptions.length >= 2) state.project.area_id = selectedOptions[2].value

  CityshowPicker.value = false
}

const onCityChange = async (data: { value: number }) => {
  console.log('cascaderValue', cascaderValue.value)

  state.pid = data.value
  const res = await getCity({ Pid: state.pid })
  if (res.code == 200) {
    if (res.data) {
      state.city_list.forEach(i => {
        // console.log('二级联动', data.value)
        for (let l = 0; l < i.children.length; l++) {
          if (data.value === i.children[l].value) {
            let children = []
            for (let e = 0; e < res.data.length; e++) {
              children.push({ text: res.data[e].name, value: res.data[e].id, children: null })
            }
            i.children[l].children = children
          }
        }
        if (data.value == i.value) {
          for (let e = 0; e < res.data.length; e++) {
            i.children.push({ text: res.data[e].name, value: res.data[e].id, children: [] })
          }
        }
      })
    }
  }
}

// 省市区查询功能
const get_region = async () => {
  let data = { Pid: state.pid }
  const res = await getCity(data)
  if (res.code == 200) {
    if (res.data) {
      res.data.forEach(e => {
        state.city_list.push({ text: e.name, value: e.id, children: [] })
      })
      console.log(state.city_list)
    }
  }
}

const formatDate = date => {
  console.log('date: ', typeof date)
  return `${dayjs(date).format('YYYY-MM-DD')}`
}

const onSubmit = async () => {
  const res = await ConstructionApply(state.formData)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}
const get_project_detail = async () => {
  let rqs = {
    id: state.formData.project_id
  }
  const res = await getProjectDetail(rqs)
  if (res.code == 200) {
    // console.log('get_project_detail', res.data)
    state.formData.address = res.data.area_name + res.data.address
    // state.address = res.data.address
    state.formData.finish_date = res.data?.contract?.finish_date
    project_detail.value = res.data
  }
}

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 6
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}

onMounted(() => {
  get_approve_config()
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.name = router.currentRoute.value.query.project_name.toString()
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
  get_region()
  get_project_detail()
})

const TypeName = {
  //  自定义 columns 结构中的字段
  id: 'id',
  text: 'name'
}

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_review_people = _resolveComponent("review-people")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, {
                    title: "项目名称",
                    value: _unref(state).name
                  }, null, 8, ["value"]),
                  _hoisted_3,
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.address,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.address) = $event)),
                    label: "项目地址",
                    "input-align": "right",
                    placeholder: "请输入详细地址",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.finish_date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).formData.finish_date) = $event)),
                    label: "完工时间",
                    "input-align": "right",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (EndshowPicker.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: EndshowPicker.value,
                    "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((EndshowPicker).value = $event)),
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_datetime_picker, {
                        modelValue: currentDate.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentDate).value = $event)),
                        type: "date",
                        title: "选择日期",
                        onConfirm: onEndConfirm,
                        onCancel: _cache[4] || (_cache[4] = ($event: any) => (EndshowPicker.value = false))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["show"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.liable_person,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).formData.liable_person) = $event)),
                    label: "施工负责人",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.phone,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).formData.phone) = $event)),
                    label: "联系电话",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_4,
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).waterName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).waterName) = $event)),
                    "label-width": "150",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    "input-align": "right",
                    label: "现场水电气道路情况",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (WaterShowPicker.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.supply_days,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).formData.supply_days) = $event)),
                    "label-width": "150",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    "input-align": "right",
                    label: "计划供货期限（天）",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (showCalendar.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).formData.disburden_person,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).formData.disburden_person) = $event)),
                    "label-width": "150",
                    label: "现场卸货负责人",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _unref(state).materialName,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).materialName) = $event)),
                    "label-width": "150",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    "input-align": "right",
                    label: "安装用物料准备情况",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (MaterialShowPicker.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_cell, { title: "其他说明" }, {
                    title: _withCtx(() => [
                      _hoisted_5
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        modelValue: _unref(state).formData.explain,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(state).formData.explain) = $event)),
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入说明",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_6,
          _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
          _hoisted_7,
          _createVNode(_component_review_people, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_popup, {
      show: CityshowPicker.value,
      "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((CityshowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: cascaderValue.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((cascaderValue).value = $event)),
          title: "请选择所在地区",
          options: _unref(state).city_list,
          "active-color": "#1989fa",
          onClose: _cache[17] || (_cache[17] = ($event: any) => (CityshowPicker.value = false)),
          onChange: onCityChange,
          onFinish: onCityConfirm,
          swipeable: "",
          onClickTab: onClickTab
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: WaterShowPicker.value,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => ((WaterShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: waterColumns,
          "columns-field-names": TypeName,
          onConfirm: onWaterConfirm,
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (WaterShowPicker.value = false))
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: MaterialShowPicker.value,
      "onUpdate:show": _cache[22] || (_cache[22] = ($event: any) => ((MaterialShowPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: materialColumns,
          "columns-field-names": TypeName,
          onConfirm: onMaterialConfirm,
          onCancel: _cache[21] || (_cache[21] = ($event: any) => (MaterialShowPicker.value = false))
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_calendar, {
      show: showCalendar.value,
      "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => ((showCalendar).value = $event)),
      type: "range",
      onConfirm: onCalendarConfirm
    }, null, 8, ["show"])
  ]))
}
}

})